import * as types from '../mutation-types';
import { unionState, toDateTimeString } from '../helpers';

const state = () => ({
	products: [],
});


const actions = {
	fetchAll({ commit }) {
		return axios.get('/api/products/all').then(response => {
			commit(types.STORE_PRODUCTS, response.data);

			return response.data;
		});
	},

	fetch({ commit }, { id }) {
		return axios.get(`/api/products/${id}`).then(response => {
			commit(types.STORE_ONE_PRODUCT, response.data);

			return response.data;
		});
	},

	create({ commit }, { name, catalog_name, description, features, uses, tag,
		manufacturer, categoryId, unit, price, main_image, images }) {
		const formData = new FormData();
		formData.append('name', name);
		formData.append('manufacturer', manufacturer);
		formData.append('catalog_name', catalog_name);
		formData.append('description', description);
		formData.append('features', features);
		formData.append('uses', uses);
		formData.append('tag', tag);
		formData.append('price', price);
		formData.append('main_image', main_image);
		formData.append('category_id', categoryId);
		formData.append('unit', unit);

		if (images)
			for (let image of images) {
				formData.append('images[]', image);
			}
		return axios.post('/api/products', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_PRODUCT, response.data);

			return response.data;
		});
	},

	update({ commit }, { id, name, catalog_name, description, features, uses, tag,
		manufacturer, categoryId, unit, price, main_image, images }) {
		const formData = new FormData();
		formData.append('name', name);
		formData.append('manufacturer', manufacturer);
		formData.append('catalog_name', catalog_name);
		formData.append('description', description);
		formData.append('features', features);
		formData.append('uses', uses);
		formData.append('tag', tag);
		formData.append('price', price);
		formData.append('main_image', main_image);
		formData.append('category_id', categoryId);
		formData.append('unit', unit);
		formData.append('_method', 'PUT');

		if (main_image)
			formData.append('main_image', main_image);

		if (images)
			for (let image of images) {
				formData.append('images[]', image);
			}

		return axios.post(`/api/products/${id}`, formData, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(response => {
			commit(types.STORE_ONE_PRODUCT, response.data);

			return response.data;
		});
	},

	delete({ commit }, { productId }) {
		return axios.delete(`/api/products/${productId}`).then(() => {
			commit(types.DELETE_ONE_PRODUCT, productId);
		});
	},

	status({commit} , {productId , active}){
		return axios.put(`/api/products/${productId}/status` , {
			active: active
		}).then(response => {
			commit(types.PRODUCT_STATUS , productId);

			return response.data;
		});
	},
};

const mutations = {
	[types.STORE_PRODUCTS](state, products) {
		state.products = unionState(state.products, products);
	},

	[types.STORE_ONE_PRODUCT](state, product) {
		state.products = unionState(state.products, [product]);
	},

	[types.DELETE_ONE_PRODUCT](state, id) {
		const product = state.products.find(t => t.id == id);
		product.deleted_at = toDateTimeString(new Date());
	},
	[types.PRODUCT_STATUS](state, productId) {
		const product = state.products.find(c => c.id === productId);
		product.active = !product.active;
	},
};

const getters = {
	getById: state => id => state.products.find(f => f.id == id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};